function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;


//////////////////
// WEBPACK FOOTER
// ./~/yup/~/@babel/runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 123
// module chunks = 0